import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from '@direct-frontend/stdlib';
import { updateOrderProductQuantity } from '@/entities/order';
import { type OrderProductProps } from '@/shared/components/OrderProduct';
import { getRequestContext } from '@/shared/lib/requestContext';

const DEBOUNCE_TIMEOUT = 300;

export const useProductQuantity = ({
    quantity,
    variantId,
    chunkId,
    reinitialize,
}: Pick<OrderProductProps, 'quantity' | 'chunkId' | 'variantId' | 'reinitialize'>) => {
    const [currentQuantity, setCurrentQuantity] = useState(quantity);
    const [isQuantityChanged, setIsQuantityChanged] = useState(false);

    const { orderId, storeSlug, signature } = getRequestContext();

    const updateProductQuantity = useDebounce(async (newQuantity: number) => {
        await updateOrderProductQuantity({
            items: [
                {
                    id: variantId,
                    quantity: newQuantity,
                    delivery_chunk_id: chunkId,
                },
            ],
            order_id: orderId,
            signature: signature,
            store_slug: storeSlug,
            reinitialize,
        });

        setIsQuantityChanged(true);
    }, DEBOUNCE_TIMEOUT);

    const handleUpdateQuantity = useCallback(
        (quantity: number) => {
            setCurrentQuantity(quantity);
            updateProductQuantity(quantity);
        },
        [updateProductQuantity]
    );

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Без этого никак
        setCurrentQuantity(quantity);
        setIsQuantityChanged(false);
    }, [quantity, isQuantityChanged]);

    return { currentQuantity, updateQuantity: handleUpdateQuantity, clearQuantity: () => updateProductQuantity(0) };
};
